import React, {Component} from "react";
import * as prosConnect from "./ProsConnect";
import {formatDate, getEndOfWorkingDayTimeMs} from "./ProsCommonUi";
import BasicButton, {ConfirmButton} from "../components/BasicButton";
import ProsDateMenu from "./ProsDateMenu";
import {
    currentTimeMs,
    MIN_EXPIRE_TIME_MS,
    MAX_EXPIRE_TIME_MS,
    utcToLocalTime,
    getActiveProject,
    ATTR_DATE_AND_TIME, strToBool
} from "./ProsConnect";
import BasicModal, {BasicModalDismiss} from "../components/BasicModal";

/** ProsDate component is used to
 *      - render date or icon to act a button to set date
 *      - opening a popup to change time
 *
 * Props
 *      iconOnly     when true shows a calendar icon (to choose new date)
 *      timeMs      UTC time in ms - when zero using current time as a default
 *      isMissing   true when time is required but not set - use to render "missing time"
 *      timeTitle   Title for date
 *      useButtonTitle    Label for popup "use time" button, when missing popup is disabled
 *      stateIcons  optional state icons shown in calendar view close to calendar icon
 *      onTimeChanged(timeMs)   parent's callback to use selected time - onTimeChanged(selectedTimeMs)
 *
 * TODO - extend to prompt also time in addition to date when setting also time enabled in project settings
 *
 */

export default class ProsDate extends Component {
    constructor(props) {
        super(props)
        this.showHourMin = strToBool(getActiveProject().attrs[ATTR_DATE_AND_TIME])
        this.state = {
            saveTimeMs: this.props.timeMs
        }
    }

    showMenu() {
        if (this.props.useButtonTitle) {
            const customButtonSet = this.props.timeMs ? <ConfirmButton
                    btnClass={"2nd"}
                    label={"Poista määräaika..."}
                    action={()=> {
                        this.useTime(0)
                        BasicModalDismiss()
                    }}
                    btnType={"fatal"}
                    confirmAction
                /> : null
            BasicModal(this.props.timeTitle ||"Valitse aika", <ProsDateMenu
                    timeMs={this.makeValidDate(this.props.timeMs, getEndOfWorkingDayTimeMs(currentTimeMs(), this.showHourMin))}
                    onChange={timeMs => {
                        this.setState({saveTimeMs: timeMs})
                    }}
                    useButtonTitle={this.props.useButtonTitle}
                    isMissing={this.props.isMissing}
                    isMandatoryAndMissing={this.props.timeMs === 0 && (this.props.isMissing || (this.props.obs && prosConnect.getActiveProject().isExpirationDateMissing(this.props.obs)))}
                />, {
                    action: () => {
                        this.useTime(this.makeValidDate(this.state.saveTimeMs, getEndOfWorkingDayTimeMs(currentTimeMs(), this.showHourMin)))
                    },
                    customButtons: customButtonSet,
                    cancelCallback: ()=> this.setState({timeMs: this.props.timeMs}),
                    btnText: this.props.useButtonTitle
                })
        }
    }

    renderCalendarButton(){
        if (!this.props.useButtonTitle) {
            return null
        }
        return <BasicButton
            icon={"alarm"}
            size={"sm"}
            disabled={!this.props.useButtonTitle || this.props.disabled}
            action={e => {
                if (!e.shiftKey) {
                    this.showMenu()
                }
            }}
        />
    }

    useTime(timeMs) {
        this.setState({timeMs: timeMs})
        if(this.props.onTimeChanged) this.props.onTimeChanged(timeMs)
    }

    makeValidDate(timeMs, defaultTimeMs) {
        let val =  parseInt(timeMs)
        if (val > MIN_EXPIRE_TIME_MS && val < MAX_EXPIRE_TIME_MS) {
            return val
        }
        return defaultTimeMs
    }

    render() {
        if (this.props.iconOnly) {
            return <span key={this.props.tag} className={"icon-bar"}>
                {this.props.stateIcons}
                {this.renderCalendarButton()}
            </span>
        }
        if (this.props.stateIcons) {
            return this.props.stateIcons
        }
        let timeStr = (this.props.timeMs ? formatDate(utcToLocalTime(this.props.timeMs), this.showHourMin) : this.props.timeTitle ? '---' : null)
        const hasPermissions = prosConnect.hasPermissionTo("editExpiration", this.props.obs, undefined, false)
        const label = this.props.timeTitle ? <strong>{timeStr}</strong> : this.props.label || timeStr
        return <BasicButton
                key={this.props.key}
                label={label}
                icon={this.props.icon ? this.props.icon : this.props.timeTitle ? "alarm" : null}
                iconSize={this.props.iconSize}
                iconColor={this.props.iconColor || (this.props.isMissing ? "2nd" : null)}
                btnType={!hasPermissions ? "locked" : null}
                required={(this.props.timeTitle && this.props.isMissing && hasPermissions) || null}
                disabled={this.props.disabled}
                action={e => {
                    if (!e.shiftKey) {
                        e.stopPropagation()
                        this.showMenu()
                    }
                }}
                className={"btn-text-stacked"}
            >
        </BasicButton>
    }
}